import PropTypes from 'prop-types';
// @mui
import { Stack, CardContent, useTheme, CSSObject, Theme, Grid, Box, Typography, styled } from '@mui/material';
import Card from '@mui/material/Card';

export const formStyleMixin = (theme: Theme): CSSObject => ({
	borderRadius: '8px',
	boxShadow: '0 4px 12px 0 rgba(44, 62, 80, 0.16)',
	border: 'solid 1px ' + theme.palette.root.mediumGreen,
	[theme.breakpoints.down('sm')]: {
		border: 'none',
		boxShadow: 'none',
		'& .MuiCardContent-root': {
			padding: '0!important',
		},
	},
});

interface IProps {
	children?: PropTypes.ReactElementLike | PropTypes.ReactElementLike[];
	cardStyle?: any;
	sx?: any;
	title?: string;
	values?: any;
}

export const FormCard = (props: IProps) => {
	const theme = useTheme();
	let cardStyle = { ...formStyleMixin(theme) };
	if (props.cardStyle?.width) {
		cardStyle = { ...cardStyle, width: props.cardStyle.width };
	}
	return (
		<Card
			sx={{
				...cardStyle,
			}}
		>
			<CardContent sx={{ padding: '24px', ...props.sx }}>
				{props.title && (
					<Typography
						component={'div'}
						variant="pageTitle"
						sx={{ mb: 3 }}
						color={theme.palette.root.formTitle}
					>
						{props.title}
					</Typography>
				)}
				<Stack
					spacing={{ xs: 2, sm: 5 }}
					sx={{
						'& .editButton': {
							position: 'relative',
							'&::before': {
								border: '1px solid red',
								width: '40px',
								height: '40px',
								borderRadius: '50%',
								background: theme.palette.root.lightGreen,
								position: 'absolute',
								content: '"sdsdsd"',
								zIndex: 0,
							},
						},
					}}
				>
					{props.children}
				</Stack>
			</CardContent>
		</Card>
	);
};

export const FormCardLayout = (props: IProps) => {
	const theme = useTheme();
	const { sx } = props;
	return (
		<Box
			sx={{
				width: theme.sizes.CARD_WIDTH * 2 + 32,
				margin: 'auto',
				display: 'flex',
				flexWrap: 'wrap',
				gap: 4,
				...sx,
				[theme.breakpoints.down('xl')]: {
					width: 'auto',
				},
				'& .MuiCard-root': {
					width: theme.sizes.CARD_WIDTH,
				},
			}}
		>
			{props.children}
		</Box>
	);
};

export const FormCardSingleColumnLayout = (props: IProps) => {
	const theme = useTheme();
	return (
		<Stack
			sx={{
				width: theme.sizes.CARD_WIDTH,
				margin: 'auto',
				gap: 4,
				'& .MuiCard-root': {
					width: theme.sizes.CARD_WIDTH,
				},
			}}
		>
			{props.children}
		</Stack>
	);
};

export const FormCard2ColumnLayout = styled(Stack)((props) => ({
	gap: 2,
	justifyContent: 'space-between',
	margin: 'auto',
	marginTop: '1rem',
	flexDirection: 'row',
	width: props.theme.sizes.CARD_WIDTH * 2 + 32,
	[props.theme.breakpoints.down('xl')]: {
		//flexDirection: 'column',
		width: props.theme.sizes.CARD_WIDTH,
		margin: 0,
		marginTop: '1rem',
	},
}));

export const FormCard1ColumnLayout = styled(Stack)((props) => ({
	justifyContent: 'space-between',
	margin: 'auto',
	marginTop: '1rem',
	flexDirection: 'row',
	width: 'min-content',
	'& .MuiButton-root': {
		margin: '0 8px!important',
	},
}));

export const FormEditButton = styled(Box)((props) => ({
	width: '40px',
	height: '40px',
	borderRadius: '50%',
	position: 'absolute',
	right: 0,
	zIndex: 0,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	top: '-10px',
	cursor: 'pointer',
	'&.active': {
		background: props.theme.palette.root.lightGreen,
	},
}));
